<template>
	<div class="login-view-root register-view-root" :class="{'no-background': isEmbedded}">

		<!--    <div class="body-div layout-centered bg-img" style="" :style="{backgroundImage: 'url(' + require('@/assets/img/bg/8.jpg') + ')'}">-->
		<div class="layout-centered bg-img"
		:class="{'body-div': !isEmbedded}">

			<!--    <div class="layout-centered bg-img" style="background-image:url('@/assets/img/bg/4.jpg')">-->


			<!-- Main Content -->
			<!-- Main Content -->
			<main class="mx-md-5" :class="{'main-content': !isEmbedded}">

<!--				:style="{'min-width': isEmbedded ? '440px' : '540px'}"-->
				<div class="mw-100"
					 :class="{'bg-white shadow-7 p-5 m-3': !isEmbedded}"
					 :style="{'width': '100%'}"
					 @mouseup="clearFormValidationInternal">
					<slot name="register-title">
						<h4 class="mb-2">{{getTitle(stepNumber)}}</h4>
					</slot>

					<div v-if="getDescription(stepNumber)" class="mb-2">
						{{getDescription(stepNumber)}}
					</div>

					<div class="row mx-0 mb-5">
						<div v-if="requestCreditCard">Step {{ stepNumber }} of {{numberOfSteps}}</div>
						<div class="layout-spacer"/>
						<div v-if="stepNumber > 1">
							<a @click="stepNumber--">Back</a>
						</div>
						<div v-if="stepNumber === 1 && showClose">
							<a @click="onCloseClicked">Close</a>
						</div>

					</div>

					<div v-for="(step) of stepNumberArrayComputed" :key="step">
						<slot v-if="step === stepNumber && !isStepReserved(step)" :name="'step' + step" :next="nextClicked"/>
					</div>

					<div v-if="stepNumber === stepNumberAccountData">


						<el-form :model="form"
								 :rules="rules"
								 ref="mainForm"
								 class="qwoach-form"
								 novalidate="novalidate"
								 @submit.native.prevent
						>
							<FormTextRow
								prop="fullName"
								v-model="form.fullName"
								placeholder="Your Full Name"
							/>
							<FormTextRow
								prop="email"
								type="email"
								v-model="form.email"
								placeholder="Email Address"
							/>
							<FormTextRow
								prop="password"
								type="password"
								v-model="form.password"
								placeholder="Password"
							/>
							<FormTextRow
								prop="passwordConfirm"
								type="password"
								v-model="form.passwordConfirm"
								placeholder="Password (confirm)"
							/>
<!--							<el-form-item prop="fullName" class="form-group mb-4 pt-2">-->
<!--								<input type="text" class="form-control" name="name" v-model="form.fullName"-->
<!--									   placeholder="Your Full Name">-->
<!--							</el-form-item>-->

<!--							<el-form-item prop="email" class="form-group mb-4 pt-2">-->
<!--								<input type="email" class="form-control" name="email" v-model="form.email"-->
<!--									   placeholder="Email Address">-->
<!--							</el-form-item>-->

<!--							<el-form-item prop="password" class="form-group mb-4 pt-2">-->
<!--								<input type="password" class="form-control" name="password" v-model="form.password"-->
<!--									   placeholder="Password">-->
<!--							</el-form-item>-->

<!--							<el-form-item prop="passwordConfirm" class="form-group mb-5 pt-2">-->
<!--								<input type="password" class="form-control" name="password-confirm"-->
<!--									   v-model="form.passwordConfirm" placeholder="Password (confirm)">-->
<!--							</el-form-item>-->

<!--							<el-form-item prop="isTermsChecked" class="form-group py-3">-->
<!--								<div class="custom-control custom-checkbox">-->
<!--									<input type="checkbox" class="custom-control-input" id="terms_box"-->
<!--										   v-model="form.isTermsChecked">-->
<!--									<label class="custom-control-label" for="terms_box">I agree to the <a class="ml-1"-->
<!--																										  href="terms.html"-->
<!--																										  target="_blank">terms-->
<!--										of service</a></label>-->
<!--								</div>-->
<!--							</el-form-item>-->

							<div class="form-group text-center">
								<qw-button size="default" class="w-100" type="primary" :loading="isProgressShowing"
										   @click="submitForm()">
									<span v-if="requestCreditCard">Next</span>
									<span v-else>{{actionButtonText}}</span>
								</qw-button>
								<div class="py-3" v-if="!requestCreditCard && canShowNoCCMessage">
									No credit card required
								</div>
							</div>
						</el-form>
						<div v-if="errorMessage" class="text-danger py-3">
							{{ errorMessage }}
						</div>


						<!--                <div class="divider">Or Register With</div>-->
						<!--                <div class="text-center">-->
						<!--                    <a class="btn btn-circle btn-sm btn-facebook mr-2" href="#"><i class="fa fa-facebook"></i></a>-->
						<!--                    <a class="btn btn-circle btn-sm btn-google mr-2" href="#"><i class="fa fa-google"></i></a>-->
						<!--                    <a class="btn btn-circle btn-sm btn-twitter" href="#"><i class="fa fa-twitter"></i></a>-->
						<!--                </div>-->

						<hr class="w-30">

						<p v-if="showLoginLink" class="text-center text-muted small-2 py-3">Already a member?
							<a v-if="isEmbedded" :href="loginLink" target="_blank">Login here</a>
							<router-link v-else :to="loginLinkName">Login here</router-link>
						</p>
					</div>


					<div v-else-if="stepNumber === stepNumberPayment">

						<div>
							<div class="mb-4">
								<div style="padding: 0 13px">

<!--									<h4 v-if="isSpecialTrial">Start your free 6-Month Trial of Qwoach Essentials-->
<!--										Monthly</h4>-->
<!--									<h4 v-else-if="isSpecialContributor">Start your special Life-Time Discount of Qwoach-->
<!--										Contributor Monthly</h4>-->
<!--									<h4 v-else>Join Qwoach Core Contributors community</h4>-->
									<h4>Join {{productNameComputed}}</h4>
									<p v-if="payThen">Cancel anytime</p>
									<p v-if="settingsExtraMessage">{{settingsExtraMessage}}</p>

									<div v-if="isPaddleLoading" class="text-center my-5">
										<i class="fontello icon-spin5 mr-1"/>Loading...
									</div>
									<div v-else class="mt-5">

										<div class="card p-2">
											<div v-if="canShowYearlySwitch" class="mb-4">
												<el-switch
													inactive-text="Monthly"
													:active-text="switchYearlyText"
													v-model="isShowYearly"
													@change="showPaddle"/>
												<div v-if="yearlyPlanMonthlyPrice">
													Pay as little as ${{yearlyPlanMonthlyPrice}}/month when billed yearly
												</div>
												<hr/>

											</div>
											<div class="mb-2" v-if="!isGenogramDemo">{{ planName }}</div>
											<div><span class="bold">Pay today: </span>
												<span class="strike-through" v-if="saveNow && saveNow !== payNow">{{ this.saveNow }}</span>
												{{ this.payNow }} {{ this.currency }}<span v-if="payNow">/{{ this.payIntervalType }}</span><span
													v-if="taxThen && this.payNow > 0">*</span></div>
											<div v-if="this.payThen && this.payNow !== this.payThen">
												<span class="bold">Pay in {{secondChargeTimePeriod}}: </span>
												<span v-if="saveThen && saveThen !== payThen" class="strike-through">{{ this.saveThen }}</span>
												{{ this.payThen }} {{ this.currency }}/{{ this.payIntervalType }}<span
												v-if="taxThen">*</span></div>
											<div class="text-muted mt-2">
												<small>
													<div v-if="taxThen">

														<div>
															*The prices above include Sales Tax.
															<ToolTipView :analyticsProps="tooltipAnalyticsProps" >
																Depending on your country, the price can include a standard
																tax called VAT which is regulated by the government of your
																country.
																<br/><br/>
																If you are a registered businesses, you can enter your VAT
																number below to remove the tax from the price or to further claim the VAT return.
																<br/><br/>
																The exact behavior may depend on the local regulations of your country.
															</ToolTipView>
														</div>

														<div>Click "Add VAT number" below to remove the Tax.</div>
													</div>
												</small>
											</div>
										</div>

										<div v-if="showStudentEnrollment"
											 class="my-5 text-right p-3 border-2"
											style="background-color: rgba(255, 218, 185, 0.5);">
											Student? <qw-link-button @click="studentEnrollClicked">Get free access</qw-link-button>
										</div>

									</div>

								</div>
							</div>
							<!--							<div>-->
							<!--								<el-button @click="testPaddleHook">Paddle Webhook</el-button>-->
							<!--								<el-button @click="onPaymentSuccess">Payment success</el-button>-->
							<!--								<el-button @click="testPaddleHookAndPaymentSuccess()">Both</el-button>-->
							<!--							</div>-->
<!--							<div class="checkout-container relative" :style="{'padding-bottom1': paddingBottomCheckout}">-->

<!--							</div>-->

							<div class="checkout-container relative" :style="{'padding-bottom1': paddingBottomCheckout}">
<!--								Your 30-day trial starts today. Within these 30 days, if you change your mind, you can cancel your plan and not be billed. On 6 Jan 2022, we will begin billing you $20 USD per month until you cancel your subscription. Previous charges won’t be refunded when you cancel unless it’s legally required.
cehckbox -> I agree to the Qwoach Terms, Privacy Policy, Refund Policy and Automatic Renewal Terms above.
-->
<!--								<div v-if="!isPaddleLoading" class="text-muted text-note absolute1"-->
<!--									 style="bottom: 0; left: 0; right: 0; height1: 370px; width:100%; background: white; padding: 1.3rem"-->
<!--								:style="{'height': orderNoteHeight}">-->
<!--									<span v-if="isSpecialTrial">By placing this order, I agree to the {{productNameComputed}} <a href="https://qwoach.com/terms" target="_blank">Terms of Use</a>, and give Qwoach permission to charge my credit card for {{this.payThen}}{{this.currency}}/{{this.payIntervalType}}<span v-if="taxThen">*</span> after the 6 months trial is up.</span>-->
<!--									<span v-else>By placing this order, I agree to the {{productNameComputed}} <a href="https://-->
<!--									.com/terms" target="_blank">Terms of Use</a>, and give {{productNameComputed}} permission to charge my credit card for {{this.payThen || this.payNow}}{{this.currency}}/{{this.payIntervalType}}<span v-if="taxThen">*</span><span v-if="payNow == 0"> in {{secondChargeTimePeriod}}</span>.</span>-->
<!--&lt;!&ndash;									for the next 6 months and then special price of ${{this.payThen}}{{this.currency}}/{{this.payIntervalType}}<span v-if="taxThen">*</span> after the 6 months period is up.</span>&ndash;&gt;-->
<!--									<div v-if="taxNow" class="mt-4">*Have a VAT number? Enter it above to remove the Sales Tax from the price.</div>-->

<!--&lt;!&ndash;									<div class="sc-bwzfXH bDcmNo my-5">&ndash;&gt;-->
<!--&lt;!&ndash;										<div font-size="10px" class="sc-cSHVUG ktEtCx">This order process is conducted by our online reseller &amp; Merchant of Record Paddle.com.</div>&ndash;&gt;-->
<!--&lt;!&ndash;										<div font-size="1.2em" class="sc-cSHVUG euKYoy">Your data will be shared with Qwoach LLC for product fullfillment. Paddle.com Market Ltd, Judd House, 18-29 Mora Street, London EC1V 8BT.</div>&ndash;&gt;-->
<!--&lt;!&ndash;										<a font-size="1.2em" href="https://paddle.com/legal-buyers/" target="_blank" rel="noopener noreferrer" class="sc-gZMcBi biITmK">Paddle.com Terms &amp; Conditions</a> <span class="sc-eNQAEJ gIIoKl">|</span> <a font-size="1.2rem" href="https://paddle.com/privacy-buyers/" target="_blank" rel="noopener noreferrer" class="sc-gZMcBi biITmK">Paddle.com Privacy Policy</a>&ndash;&gt;-->
<!--&lt;!&ndash;									</div>&ndash;&gt;-->
<!--								</div>-->

							</div>
							<div v-if="!isPaddleLoading" class="text-muted text-note absolute1"
								 style="bottom: 0; left: 0; right: 0; height1: 370px; width:100%; background: white; padding: 1.3rem"
								 :style="{'height': orderNoteHeight}">
								<span v-if="isSpecialTrial">By placing this order, I agree to the {{productNameComputed}} <a href="https://qwoach.com/terms" target="_blank">Terms of Use</a>, and give Qwoach permission to charge my credit card for {{this.payThen}}{{this.currency}}/{{this.payIntervalType}}<span v-if="taxThen">*</span> after the 6 months trial is up.</span>
								<span v-else>By placing this order, I agree to the {{productNameComputed}} <a href="https://
									.com/terms" target="_blank">Terms of Use</a>, and give {{productNameComputed}} permission to charge my credit card for {{this.payThen || this.payNow}}{{this.currency}}/{{this.payIntervalType}}<span v-if="taxThen">*</span><span v-if="payNow == 0"> in {{secondChargeTimePeriod}}</span>.</span>
								<!--									for the next 6 months and then special price of ${{this.payThen}}{{this.currency}}/{{this.payIntervalType}}<span v-if="taxThen">*</span> after the 6 months period is up.</span>-->
								<div v-if="taxNow" class="mt-4">*Have a VAT number? Enter it above to remove the Sales Tax from the price.</div>

								<!--									<div class="sc-bwzfXH bDcmNo my-5">-->
								<!--										<div font-size="10px" class="sc-cSHVUG ktEtCx">This order process is conducted by our online reseller &amp; Merchant of Record Paddle.com.</div>-->
								<!--										<div font-size="1.2em" class="sc-cSHVUG euKYoy">Your data will be shared with Qwoach LLC for product fullfillment. Paddle.com Market Ltd, Judd House, 18-29 Mora Street, London EC1V 8BT.</div>-->
								<!--										<a font-size="1.2em" href="https://paddle.com/legal-buyers/" target="_blank" rel="noopener noreferrer" class="sc-gZMcBi biITmK">Paddle.com Terms &amp; Conditions</a> <span class="sc-eNQAEJ gIIoKl">|</span> <a font-size="1.2rem" href="https://paddle.com/privacy-buyers/" target="_blank" rel="noopener noreferrer" class="sc-gZMcBi biITmK">Paddle.com Privacy Policy</a>-->
								<!--									</div>-->
							</div>
						</div>


					</div>
				</div>

			</main><!-- /.main-content -->


		</div>
		<LoadingIndicator/>
	</div>
</template>


<script>

import * as emailValidator from "email-validator"
import ToolTipView from "@/core/components/Form/Base/ToolTipView.vue";


import BaseComponent from "@/core/components/BaseComponent.vue";
import {addScript} from "@/utils/helpers";
import FormTextRow from "@/core/components/Form/FormTextRow.vue";
import LoadingIndicator from "@/core/components/LoadingIndicator.vue";
import {createDialogLazy} from "@/utils/helpers-external";
let StudentGenogramEnrolDialog = () => import("@/core/modules/Login/StudentGenogramEnrolDialog.vue");
import {messageDialog} from "@/core/components/Dialogs/dialog";
import {mapPlanDev} from "@shared/DevPlanMapper";
import {trySetupPaddleForce} from "@/entry/setupPaddle";
import {SettingNameEnum} from "@shared/enums/SettingNameEnum";

export default {
	extends: BaseComponent,
	name: "RegisterView",
	components: {StudentGenogramEnrolDialog, LoadingIndicator, FormTextRow, ToolTipView},
	props: {
		requestCreditCardProp: {Boolean, default: true},//TODO this needs to be determined on server
		actionButtonTextProp: String,
		canShowNoCCMessage: {Boolean, default: true},
		numberOfSteps: {Number, default: 2},
		stepNumberAccountData: {Number, default: 1},
		stepNumberPayment: {Number, default: 2},
		titleMap: {Object, default: () => ({})},
		descriptionMap: {Object, default: () => ({})},
		isEmbedded: Boolean,
		showClose: Boolean,
		isLoginCoach: Boolean,
		userExtraProps: Object,
		specialId: String,
		tooltipAnalyticsProps: Object,
		extra: String,
		planIdMonthly: String,
		planIdYearly: String,
		settings: {Object, default: () => ({})},
		showLoginLink: {Boolean, default: true},
		productName: String,
	},
	watch:{
		specialId:{
			immediate: true,
			handler(){
				this.onSpecialIdChanged()
			}
		},
		titleMap:{
			immediate: true,
			handler(){
				this.setupTitleMap()
			}
		},
		descriptionMap:{
			immediate: true,
			handler(){
				this.setupDescriptionMap()
			}
		},
	},

	data() {
		return {
			orderNoteHeight: "auto",//"370px",
			paddingBottomCheckout: "185px",
			titleMapData: {},
			descriptionMapData: {},
			isShowYearly: true,
			subscribeButtonName: "Subscribe Now",
			location: {},
			stepNumber: 1,
			planId: "762957",//601238,
			currentForm: 'signup',
			isPaddleLoading: false,
			saveNow:"",
			saveThen:"",
			payNow:"",
			payThen:"",
			currency:"",
			payIntervalType:"",
			payIntervalLength:"",
			trialDays: 0,
			taxNow:0,
			taxThen:0,
			secondChargeTimePeriod: "1 month",
			planName:"",
			planItem: null,
			studentUserId: "",
			unlockOnPurchase: false,

			paddleCheckoutEventListener: null,
			paymentStartTs: new Date().getTime(),
			form: {
				fullName: "",
				email: "",
				password: "",
				passwordConfirm: "",
				isTermsChecked: false
			},
			rules: {
				isTermsChecked: [
					{
						required: true,
						whitespace: false,
						validator: (rule, value, callback, source, options) => {
							let errorMsg = value ? undefined : "Please check terms"
							callback(errorMsg);
						},
						trigger: 'validate'
					},
				],


				fullName: [
					{
						required: true,
						whitespace: false,
						message: 'Please provide your name',
						trigger: 'validate'
					},
				],
				email: [
					{
						required: true,
						whitespace: false,
						validator: (rule, value, callback, source, options) => {
							let res = emailValidator.validate(this.form.email);
							let errorMsg = res ? undefined : "Please provide valid email address"
							callback(errorMsg);
						},
						trigger: 'validate'
					},
				],
				password: [
					{
						required: true,
						whitespace: false,
						validator: (rule, value, callback, source, options) => {
							let errorMsg;
							if (!this.form.password.length) {
								errorMsg = "Password is required"
							} else if (this.form.password.length < 6) {
								errorMsg = "Password is too short (6 characters minimum)"
							}
							callback(errorMsg);
						},
						trigger: 'validate'
					},
				],
				passwordConfirm: [
					{
						required: true,
						whitespace: false,
						validator: (rule, value, callback, source, options) => {
							let errorMsg;
							if (this.form.password !== this.form.passwordConfirm) {
								errorMsg = "Password and Confirm Password don't match"
							}
							callback(errorMsg);
						},
						trigger: 'validate'
					},
				],

			},

		}
	},




	created(){
		// if(isDevEnv && !this.specialId){
		this.studentUserId = this.cookie.owner.get() || this.dataManager.generateUid()
		// if(isDevEnv){
		// 	this.planId = "10550"//10550
		// }
		// this.progressDataLoading("Setting up your account...\nPlease don't refresh this tab.")
	},

	mounted(){
		this.paddleCheckoutEventListener = this.onPaddleEvent.bind(this)
		document.addEventListener("paddle_checkout_event", this.paddleCheckoutEventListener);
		console.log("RegisterView: mounted")
	},

	beforeUnmount(){
		if(this.paddleCheckoutEventListener){
			document.removeEventListener("paddle_checkout_event", this.paddleCheckoutEventListener);
			this.paddleCheckoutEventListener = null
		}
		console.log("RegisterView: beforeUnmount")
	},


	methods: {


		setupTitleMap(){
			this.titleMapData = this.titleMap
			if(!this.titleMapData[this.stepNumberAccountData]){
				this.titleMapData[this.stepNumberAccountData] = "Create Account"
			}
			if(!this.titleMapData[this.stepNumberPayment]){
				this.titleMapData[this.stepNumberPayment] = "Create Account"
			}
		},


		setupDescriptionMap(){
			this.descriptionMapData = this.descriptionMap
		},


		async loadPlan(){
			if(this.planId && this.planId.startsWith("qw")){
				this.planItem = await this.handleAsync(this.dataManager.apiGetPlanItemPublic({planId: this.planId}))
			}
		},

		async onSpecialIdChanged(){
			let specialId = this.$route.query.specialId || this.specialId
			console.log("onSpecialIdChanged: specialId = ", specialId, ", this.$route.query.specialId = ", this.$route.query.specialId)
			switch (specialId) {
				default:
					this.planId = specialId
			}
			await this.loadPlan()

			console.log("onSpecialIdChanged: this.planId = " + this.planId)
		},

		nextClicked(){
			this.stepNumber++
		},

		isStepReserved(step){
			return step === this.stepNumberAccountData || step === this.stepNumberPayment
		},

		async onCloseClicked(){
			this.$emit("onClose")
		},

		clearFormValidationInternal(){
			this.errorMessage = ""
			this.clearFormValidation()
		},

		async onFormValidated() {
			try {
				this.progressNonBlocking()
				if (await this.$dataManager.isUserExist(this.form.email)) {
					this.errorMessage = 'User with this email already exists. Try to login instead.'
					this.hideProgress()
					return
				}
				this.location = await this.$dataManager.apiPostZip()
				this.performingRequest = false
				this.hideProgress()
				await this.onEmailSubmitted()
				if(this.requestCreditCard){
					this.stepNumber++
					this.$nextTick(() => this.showPaddle())
				} else {
					await this.createAccount({showProgress: true, isFreeUser: true})
				}
			} catch (error) {
				this.performingRequest = false
				this.handleError(error)
			}
		},

		async onEmailSubmitted(){
			let email = this.form.email
			try{
				await this.emitPromise("emailSubmitted", email)
			} catch (e) {
				console.error(e)
			}
			await this.analyticsLogExtraProps()
			let _ = this.$analyticManager.trackEvent("Email submitted", {
				email,
				...this.analyticsPropsMethod()
			})
		},



		async studentEnrollClicked(){
			this.$analyticManager.trackEvent("Student enroll clicked")

			// the below creation logic should be refactored into a separate file
			// await this.emitPromise("studentEnrollClicked")

			let studentEnrollDialog = createDialogLazy(StudentGenogramEnrolDialog)
			let userId = this.studentUserId

			let res = await studentEnrollDialog({
				userId
			})

			if(res){
				await this.createStudentAccountLocked({uid: userId})
			}

		},

		async createStudentAccountLocked(options = {}) {
			console.log("createStudentAccountLocked")
			//this.progressBlocking is not working in AppLight so we use progressDataLoading instead
			this.progressDataLoading("Saving your genogram...\nPlease don't refresh this tab.")
			// this.progressBlocking("Saving your genogram...\nPlease don't refresh this tab.")
			let profileData = this.createProfileData()
			profileData = {
				...profileData,
				...options
			}
			try {
				let {userProfile, created} = await this.$dataManager.apiPostCreateStudentAccountLocked(profileData) || {}
				if(created){
					let _ = this.$analyticManager.trackEvent("Student enrollment confirmed", this.analyticsPropsMethod())
					this.$emit("lockedAccountCreated", userProfile)
				}
				this.unlockOnPurchase = true
				await this.$authManager.logUserLoggedIn(userProfile, true)
				this.cookie.owner.set(userProfile.id)

				await messageDialog({
					title: "Genogram Saved!",
					message: "Your genogram has been saved. When your teacher/superviser completes the enrollment, you'll get an email notification to access your genogram.<br/><br/>Need your genogram right away? <br/><br/>Just complete the purchase and we'll refund your entire payment as soon as your teacher/superviser completes the enrollment."
				})
			} catch (error) {
				this.handleError(error)
			}
			this.hideProgress()
		},

		async showPaddle() {
			this.isPaddleLoading = true
			await this.setupPaddle()
			let coupon = this.$cookies.get("cpcd")
			let affiliateId = this.$cookies.get("avndrid")
			console.log("this.location = ", this.location, ", coupon = ", coupon, ", this.planId = ", this.planId, ", affiliateId = ", affiliateId)

			let response = await this.loadCheckoutLink()

			let amplitudeSessionId = this.$analyticManager.getAmplitudeSessionId()
			let amplitudeDeviceId = this.$analyticManager.getAmplitudeDeviceId()

			console.log("response = ", response)
			let {url, trialDays} = response
			this.trialDays = trialDays
			let planId = this.planIdComputed

			console.log("RegisterView.showPaddle: planId = ", planId)

			let paddleCheckoutOptions = {
				override: url,
				coupon: coupon,
				method: 'inline',
				frameTarget: 'checkout-container',
				frameInitialHeight: 416,
				frameStyle: 'width:100%; min-width1:450px; background-color: white; border: none;',
				email: this.form.email,
				country: this.location.countryCode,
				postcode: this.location.zip,
				disableLogout: true,
				allowQuantity: false,
				product: planId,
				passthrough: {amplitudeDeviceId},
				successCallback: this.onPaymentSuccess.bind(this)
			}
			console.log("RegisterView.showPaddle: paddleCheckoutOptions = ", paddleCheckoutOptions)
			window.Paddle.Checkout.open(paddleCheckoutOptions)
			this.listenForFrameHeightChange()
			await this.trackEvent("Open payment form", {planId: this.planId, override: response, coupon: coupon})
			this.$emit("paymentFormOpened")

		},

		async setupPaddle(){
			await addScript("https://cdn.paddle.com/paddle/paddle.js")
			trySetupPaddleForce()
		},

		async loadCheckoutLink(){
			let affiliateId = this.$cookies.get("avndrid")
			let shouldGenerateLink = this.$route.query.qwl
			let extra = this.$route.query.extra
			let isCoreContributor = false
			let override = {}
			if(affiliateId || isCoreContributor || shouldGenerateLink || extra){
				let overrideResponse = await this.$dataManager.apiPostGeneratePayLink({
					product_id:this.planId,
					affiliate_id: affiliateId,
					isCoreContributor: isCoreContributor,
					extra: extra
				})
				override = overrideResponse
			}
			return override
		},

		async loadPricesData(productId){
			return new Promise(resolve => {
				window.Paddle.Product.Prices(productId, 1, resolve)
			})
		},

		getTitle(stepNumber){
			return this.titleMapData[stepNumber] || "Create Account"
		},
		getDescription(stepNumber){
			return this.descriptionMapData[stepNumber]
		},

		async onPaddleEvent(data) {
			console.log("RegisterView.onPaddleEvent: data = ", data)
			data = data.detail
			this.setupPadding(data)
			if(!data.eventData.product){
				return
			}
			let product = data.eventData.product
			let {id: productId, name: productName} = product
			let prices = await this.loadPricesData(productId)
			console.log("prices = ", prices)
			this.planName = productName
			this.isPaddleLoading = false
			console.log("onPaddleEvent: data1 = ", data)
			if(prices.recurring){
				this.setupRecurringPricing(data, prices)
			} else if(prices.price){
				this.setupOneOffPricing(data, prices)
			}


			let _ = this.$analyticManager.trackEvent(data.event, {
				category: "Signup coach page",
				label: data.eventData ? (data.eventData.payment_method || data.eventData.error) : undefined,
				data: JSON.stringify(data),
				...this.analyticsPropsMethod()
			})

		},

		listenForFrameHeightChange(){
			setTimeout(() => {
				let frame = document.querySelector(".paddle-frame")
				if(frame){
					let observer = new ResizeObserver(() => {
						this.setupPadding()
					})
					observer.observe(frame)
				}
			}, 1000)

		},

		setupPadding(data){
			let frameElem = document.querySelector(".paddle-frame")

			if(!frameElem){
				return
			}

			let frameHeight = frameElem.clientHeight
			console.log("frameHeight = ", frameHeight)
			this.paddingBottomCheckout = (frameHeight - 600) + 185 + "px"
			console.log("frameHeight this.paddingBottomCheckout = ", this.paddingBottomCheckout)
			//638 -> 185
			//687 -> 220
			// if(data){
			// 	if(data.event === "Checkout.Loaded"){
			// 		return
			// 	}
			// 	if(data.event === "Checkout.Customer.Details"){
			// 		// this.orderNoteHeight = "auto"
			// 		this.paddingBottomCheckout = "220px"
			// 	}
			// 	else {
			// 		this.paddingBottomCheckout = "185px"
			// 	}
			// } else {
			// 	this.paddingBottomCheckout = "185px"
			// }

		},

		trackBuy(response){
			console.log("RegisterView.trackBuy: response = ", response)
			let value = 0
			try{
				value = Number(response.checkout.prices.vendor.total)
			} catch (e) {
				console.error(e)
			}

			if(value > 0) {
				this.$analyticManager.trackEvent("Purchase completed", {value})
			}
			this.trackCapterraBuy()
		},

		trackCapterraBuy(){
			let utmSource = this.$cookies.get("initial_utm_source")
			let capterraSources = ["capterra", "get_app", "software_advice"] //need to confirm exact values for get_app and software_advice

			if(capterraSources.includes(utmSource)){
				let img = document.createElement("img")
				img.src = "https://ct.capterra.com/capterra_tracker.gif?vid=2135662&vkey=7ae3c700d141ad490b445b900d42c5ab"
				document.body.appendChild(img)
			}
		},

		async trackGoogleBuy(){
			await addScript("https://www.googletagmanager.com/gtag/js?id=AW-385937657", "gtag_tracking")
			window.dataLayer = window.dataLayer || [];
			function gtag(){window.dataLayer.push(arguments);}
			gtag('js', new Date());

			gtag('config', 'AW-385937657');
			gtag('event', 'conversion', {
				'send_to': 'AW-385937657/zOCTCL_Y74ACEPnhg7gB',
				'value': 0.0,
				'currency': 'USD',
			});
		},

		async onPaymentSuccess(response) {
			console.log("RegisterView.onPaymentSuccess: response = ", response)
			await this.createAccount({progressMessage: "Processing your order...\nPlease don't refresh this tab."})
			console.log("RegisterView.onPaymentSuccess: createAccount completed")
			this.trackBuy(response)
		},


		async createAccount(options = {}){
			console.log("RegisterView.createAccount: options = ", options)
			let {isFreeUser, progressMessage} = options


			//this.progressBlocking is not working in AppLight so we use progressDataLoading instead
			this.progressDataLoading(progressMessage || "Setting up your account...\nPlease don't refresh this tab.")
			// this.progressBlocking(progressMessage || "Setting up your account...\nPlease don't refresh this tab.")

			let profileData = this.createProfileData()
			try {
				if(isFreeUser){
					await this.$dataManager.apiPostCreateCoachProfileSpecialFreeTrial(profileData)
				} else {
					await this.$dataManager.apiPostCreateCoachProfile(profileData)
				}
				let coachProfile = await this.$authManager.login(profileData.email, profileData.password, true)
				console.log("RegisterView.createAccount: login = ", coachProfile)
				let subscription = await this.$authManager.waitForUserSubscription({
					userId: coachProfile.id,
					paymentStartTs: this.paymentStartTs,
					predicate: (subscription) => subscription.isStarted() || isFreeUser
				});
				console.log("RegisterView.createAccount: subscription = ", subscription)

				await this.onPaymentProcessed(subscription)


			} catch (error) {
				this.hideProgress()
				this.handleError(error)
			}
		},

		async onPaymentProcessed(subscription){
			console.log("RegisterView.onPaymentProcessed: subscription = ", subscription)
			this.$analyticManager.trackEvent("User signed up")
			await this.$analyticManager.setCohortVisitParams()


			this.$authManager.setUserSubscription(subscription)
			await this.analyticsLogExtraProps()



			this.hideProgress()

			if(this.isEmbedded || this.hasListenerByName("accountCreated")){
				this.$emit("accountCreated", this.$authManager.getUserProfile())
			} else {
				this.go("CoachingProcessMainCoach")
			}
		},


		async analyticsLogExtraProps(){
			if(this.userExtraProps){
				let _ = this.$analyticManager.setUserPropsOnce({extraProps: this.userExtraProps})
			}
		},

		createProfileData() {
			return {
				email: this.form.email,
				password: this.form.password,
				name: this.form.fullName,
				isRecoveryCoach: !this.isGeneralEssentials,
				timezone: this.timezoneComputed,
				isFreePlan: this.isFreePlan,
				planId: this.planId,
				enableAccount: this.unlockOnPurchase,
				amplitudeDeviceId: this.$analyticManager.getAmplitudeDeviceId(),
				extraProps: this.userExtraProps || {},
				isGenogramDemo: this.isGenogramDemo,
			}
		},
		setupRecurringPricing(data, prices) {
			let subscriptionData = prices.recurring.subscription
			let trialDays = this.trialDays || subscriptionData.trial_days
			this.secondChargeTimePeriod = trialDays ? trialDays + " days" : subscriptionData.length + " " + subscriptionData.type

			if(trialDays){
				this.subscribeButtonName = "Subscribe now"//"Start Your Free Trial"
			}


			let firstPriceData = data.eventData.checkout.prices.customer
			let recurringPriceData = data.eventData.checkout.recurring_prices.customer
			let recurringPriceIntervalData = data.eventData.checkout.recurring_prices.interval
			let currency = firstPriceData.currency

			let taxFirst = Number(firstPriceData.total_tax);
			let totalFirst = Number(firstPriceData.total);
			let subtotalFirst = totalFirst - taxFirst
			subtotalFirst = subtotalFirst.toFixed(2)

			let totalThen = Number(recurringPriceData.total)
			let taxThen = Number(recurringPriceData.total_tax)
			let intervalTypeThen = recurringPriceIntervalData.type
			let intervalCountThen = Number(recurringPriceIntervalData.length)

			let taxPercentage = taxThen / (totalThen - taxThen)

			console.log("taxPercentage = ", taxPercentage)

			let saveNow = taxPercentage ? prices.price.gross : prices.price.net
			let saveThen = taxPercentage ? prices.recurring.price.gross : prices.recurring.price.net

			this.taxNow = taxFirst
			this.taxThen = taxThen
			this.currency = currency
			this.payNow = totalFirst
			this.payThenTotal = totalThen
			this.payThen = totalThen
			this.payThenTax = taxThen
			this.saveNow = Number(saveNow.replace(/[^0-9.]/g, ''));
			this.saveThen = Number(saveThen.replace(/[^0-9.]/g, ''));
			this.payIntervalType = intervalTypeThen
			this.payIntervalLength = intervalCountThen

			if(trialDays > 0){
				this.payNow = 0
				this.saveNow = 0
			}

			if(this.isSpecialTrial){
				this.planName = "Qwoach Essentials plan"
			} else {
				// this.planName = "Get ALL features of Qwoach"
				// this.saveNow = 89 + 89 * taxPercentage
				// this.payThen = 19 + 19 * taxPercentage
				// this.saveThen = this.saveNow
			}

		},

		setupOneOffPricing(data, prices){
			let {gross, net, tax, tax_included} = prices.price
			// let trialDays = this.trialDays || subscriptionData.trial_days
			// this.secondChargeTimePeriod = trialDays ? trialDays + " days" : subscriptionData.length + " " + subscriptionData.type

			// if(trialDays){
			// 	this.subscribeButtonName = "Start Your Free Trial"
			// }


			let firstPriceData = data.eventData.checkout.prices.customer
			// let recurringPriceData = data.eventData.checkout.recurring_prices.customer
			// let recurringPriceIntervalData = data.eventData.checkout.recurring_prices.interval
			let currency = firstPriceData.currency

			let taxFirst = Number(firstPriceData.total_tax);
			let totalFirst = Number(firstPriceData.total);
			let subtotalFirst = totalFirst - taxFirst
			subtotalFirst = subtotalFirst.toFixed(2)

			// let totalThen = Number(recurringPriceData.total)
			// let taxThen = Number(recurringPriceData.total_tax)
			// let intervalTypeThen = recurringPriceIntervalData.type
			// let intervalCountThen = Number(recurringPriceIntervalData.length)

			let taxPercentage = taxFirst / (totalFirst - taxFirst)

			console.log("taxPercentage = ", taxPercentage)

			let saveNow = taxPercentage ? prices.price.gross : prices.price.net

			this.taxNow = taxFirst
			// this.taxThen = taxThen
			this.currency = currency
			this.payNow = totalFirst
			// this.payThenTotal = totalThen
			// this.payThen = totalThen
			// this.payThenTax = taxThen
			// this.saveNow = Number(saveNow.replace(/[^0-9.]/g, ''));
			// this.saveThen = Number(saveThen.replace(/[^0-9.]/g, ''));
			this.payIntervalType = "one time"
			// this.payIntervalLength = intervalCountThen

		},
	},

	computed: {

		requestCreditCard(){
			if(!this.requestCreditCardProp){
				return false
			}
			if(this.planItem && this.planItem.freeTrialDays && !this.planItem.isCreditCardRequired){
				return false
			}
			return !this.isFreePlan
		},

		isFreePlan(){

			return this.planId === "850092" || this.planId === "free"
		},

		loginLinkName() {
			return {
				name: this.isLoginCoach ? "LoginCoach" : "Login",
				params: this.$route.params,
				query: this.$route.query,
			}
		},
		loginLink() {
			return this.resolvePathByRouteOptions(this.loginLinkName)
		},

		isSpecialTrial() {
			return this.planId === "601237"
		},
		isSpecialContributor() {
			return this.planId === "601238"
		},
		isGeneralEssentials() {
			return this.planId === "752045"
		},

		canShowYearlyComputed(){
			return this.isShowYearly && this.planIdYearlyComputed
		},

		canShowYearlySwitch(){
			return !!this.planIdYearlyComputed && (!!this.planIdMonthlyComputed)
		},

		planIdComputed(){
			if(this.canShowYearlyComputed){
				return this.planIdYearlyComputed
			}
			return this.planIdMonthlyComputed
		},

		priceMonthly(){
			return this.settings.priceMonthly || 0
		},

		priceYearly(){
			return this.settings.priceYearly || 0
		},

		planIdYearlyComputed(){
			let planId = this.settings.planIdYearly || this.planIdYearly
			planId = mapPlanDev(planId)
			return planId
		},

		planIdMonthlyComputed(){
			if(this.settings.planIdYearly && !this.settings.planIdMonthly){
				return null
			}
			let planId = this.settings.planIdMonthly || this.planIdMonthly || this.planId
			planId = mapPlanDev(planId)
			return planId
		},

		showStudentEnrollment(){
			return this.settings.showStudentEnrollment
		},

		yearlySavingPercent(){
			if(!this.priceMonthly || !this.priceYearly){
				return 0
			}

			return Math.round((1 - this.priceYearly / (12 * this.priceMonthly)) * 100)
		},

		yearlyPlanMonthlyPrice(){
			return Math.round(this.priceYearly / 12)
		},

		switchYearlyText(){
			return `Yearly (${this.yearlySavingPercent}% off)`
		},

		actionButtonText(){
			if(this.actionButtonTextProp){
				return this.actionButtonTextProp
			}
			if(this.isFreePlan){
				return "Create my free account"
			}
			if(this.planItem){
				if(this.planItem.freeTrialDays && !this.planItem.isCreditCardRequired){
					return `Start my ${this.planItem.freeTrialDays}-day free trial`
				} else {
					return "Next"
				}
			}
			return "Start my 14-day free trial"
		},

		stepNumberArrayComputed(){
			let array = []
			for(let i = 1; i <= this.numberOfSteps; i++){
				array.push(i)
			}
			return array
		},

		settingsExtraMessage(){
			return this.settings[SettingNameEnum.EXTRA_MESSAGE]
		},

		isGenogramDemo(){
			return this.form.email && this.form.email.includes("demo")
		},
		productNameComputed(){
			if(this.productName){
				return this.productName
			}
			return "Qwoach"
		},


	},
}
</script>

<style lang="scss">
//@import "../../../assets/scss/page";
/*@import "../../assets/css/page.css";*/
@import "login-view";


.register-view-root {
	.padding-x{
		padding: 0 13px;
	}
	.text-note {
		font-size: 12px;
	}

	.paddle-notice{
		position: fixed;
		bottom: 0;
		left: 0;
		right: 0;
	}

	.bDcmNo {
		font-size: 10px;
		background-color: rgb(255, 255, 255);
		height: auto;
		text-align: center;
		width: auto;
		border-width: 1px;
		border-style: solid;
		border-color: rgb(235, 236, 240);
		border-image: initial;
		border-radius: 4px;
		padding: 12px 16px 16px;
	}
	.ktEtCx {
		color: rgb(147, 147, 168);
		display: block;
		font-family: Lato, Helvetica, "Trebuchet MS", "Adobe Heiti Std", "Segoe UI", sans‑serif;
		font-size: 1.2em;
		/*font-weight: 400;*/
		line-height: 20px;
		margin-bottom: 8px;
		text-decoration: none;
	}
	.euKYoy {
		color: rgb(147, 147, 168);
		display: block;
		font-family: Lato, Helvetica, "Trebuchet MS", "Adobe Heiti Std", "Segoe UI", sans‑serif;
		font-size: 1.2em;
		/*font-weight: 400;*/
		line-height: 20px;
		margin-bottom: 8px;
		text-decoration: none;
	}
	.biITmK {
		color: rgb(6, 198, 104);
		display: inline;
		font-size: 1.2em;
		/*font-weight: 400;*/
		line-height: 2em;
		text-decoration: underline;
	}
}
</style>
